import { render, staticRenderFns } from "./sup-withdraw-bank.vue?vue&type=template&id=2f1fc63d"
import script from "./sup-withdraw-bank.vue?vue&type=script&lang=js"
export * from "./sup-withdraw-bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports